// extracted by mini-css-extract-plugin
export default {"bioSection":"Bio_bioSection__u0iB0","column":"Bio_column__FGjv3","headshot":"Bio_headshot__sTL6u","socialLinks":"Bio_socialLinks__gxEQZ"};